module.exports = __webpack_public_path__ + "static/gpx2-ff42cefafd4261401131e4da75bb6fbc.png";